module.exports = __webpack_public_path__ + "img/transformacion.c11e8683.png";